<template>
  <div class="col" style="margin-top: 150px">
    <div class="row" style="display: flex; justify-content: space-around;">
      <b-card
        class="sm-6 mv-card cmpn-card-item"
        header-class="text-center"
        title="MagiVinum"
        style="margin: 2px;">
        <template v-slot:header>
          <!-- <i class="mdi mdi-newspaper-variant-multiple" style="font-size: 32px;"></i> -->
          <b-icon icon="newspaper" style="font-size: 32px;"></b-icon>
        </template>
        <p>
          Marktplatz 17-19,<br/>
          61250, Usingen,<br/>
          Deutschland<br/>
          DE311674315
        </p>
      </b-card>
      <b-card
        class="sm-6 mv-card cmpn-card-item"
        header-class="text-center"
        title="Geschäftsführer"
        style="margin: 2px;">
        <template v-slot:header>
          <!-- <i class="mdi mdi-newspaper-variant-multiple" style="font-size: 32px;"></i> -->
          <b-icon icon="newspaper" style="font-size: 32px;"></b-icon>
        </template>
        <p>
          Margarita Spasova,<br/>
          +4917622728476<br/>
          info@magivinum.de
        </p>
      </b-card>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'Home',
  components: {
    // HelloWorld
  }
}
</script>
<style scoped>
.cmpn-card-item {
  display: flex;
  flex: 1 0 auto;
  min-width: 200px;
  width: 45%;
}
</style>
